"use client"
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

const PAYMENT_STYLE = styled.div`
& 
#collect_form_pay {
    min-height:${props => props?.$minheight || "0px"} !important;
    margin-top: 26px;
    /* @media only screen and (min-width:1440px) and (max-width: 1660px){
        min-height: 540px !important;
    } */
    /* @media only screen and (min-width:1200px) and (max-width: 1439px){
        min-height: 770px !important;
    } */
    /* @media only screen and (min-width:595px) and (max-width: 787px) {
        min-height: 540px;    
    } */

    /* @media only screen and (min-width:360px) and (max-width: 595px) {
        min-height: 770px;    
    } */

    &.dist-checkout {
        min-height: 845px;

        @media only screen and (min-width: 1536px) {
            min-height: 600px;
        }

        @media only screen and (max-width: 1280px) {
            min-height: 845px;
        }
    }

    @media only screen and (min-width: 1536px) {
        min-height: 550px;
    }

    @media only screen and (max-width: 1280px) {
        min-height: 768px;
    }
    /* @media only screen and (max-width: 797px) {        
        min-height: 540px;
    }
    @media only screen and (max-width: 605px) {        
        min-height: 770px;
    } */
}
`;

const PaymentSection = (props) => {
    const { paymentFormHtml, savedThisCard, selectedPayment, setSavedThisCard, minHeight, iframeLoader, AUTOSHIP_PRODUCTS, MEMBERSHIP_AVAILABLE, SINGLE_MEMBERSHIPCHECK, AUTOSHIP_PRODUCTS_ON_CART } = props;

    React.useEffect(() => {
        if (!iframeLoader && paymentFormHtml && typeof window !== 'undefined' && window.PaymentHandler) {
            window.submitHandleView = new window.PaymentHandler({
                frameId: 'collect_form_pay',
                frameUri: ['https://tts.teqtank.com'],
                styles: {
                    modalBackground: 'rgba(0, 0, 0, 0.8)',
                    textColor: '#FFFFFF'
                }
            });

            window.submitHandleView.on('success', (res) => {
                try {
                    console.log("SuccessResponse", res);
                    if (window.Sentry) {
                        window.Sentry.captureMessage("Payment success event received", { extra: res });
                    }
                    if (res?.orderId || res?.tempOrderId) {
                        localStorage.setItem('orderId', String(res?.orderId || res?.tempOrderId));
                    } else if (res?.token) {
                        localStorage.setItem('order_token', res?.token);
                    } else if (res?.preAuthOrderId) {
                        localStorage.setItem('preAuthOrderId', String(res?.preAuthOrderId));
                    }
                } catch (error) {
                    console.error("Error in onSuccessFunction:", error);
                    if (window.Sentry) {
                        window.Sentry.captureMessage("Error in Payment Success Handler", { extra: error });
                    }
                }
            });

            window.submitHandleView.on('error', (res) => {
                try {
                    console.log("ErrorResponse", res);
                    if (window.Sentry) {
                        window.Sentry.captureMessage("Payment Error event received", { extra: res });
                    }
                    localStorage.setItem('error-payment', res?.response || res);
                } catch (error) {
                    console.error("Error in onErrorFunction:", error);
                    if (window.Sentry) {
                        window.Sentry.captureMessage("Error in Payment Error Handler", { extra: error });
                    }
                }
            });
        }
    }, [iframeLoader, paymentFormHtml]);

    return (
        <PAYMENT_STYLE $paymentformhtml={paymentFormHtml} $minheight={minHeight} >
            {(!iframeLoader)
                ?
                <iframe id="collect_form_pay" className="w-full max-w-full border-0" title="Secure payment" src={paymentFormHtml}></iframe>
                :
                <div className='order-data loader_order text-center px-0 pt-[30px] pb-[10px]'>
                    <CircularProgress />
                </div>
            }
            {(selectedPayment?.selectedPaymentDropdown === 1) && !MEMBERSHIP_AVAILABLE && !SINGLE_MEMBERSHIPCHECK && !(AUTOSHIP_PRODUCTS?.length > 0 || AUTOSHIP_PRODUCTS_ON_CART?.length > 0) &&
                < div className="mb-4 mt-0 condition-checkout flex gap-[20px]">
                    <label className='relative'>
                        <input type="checkbox"
                            className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                            checked={savedThisCard?.checked}
                            onChange={(e) => {
                                setSavedThisCard({ ...savedThisCard, checked: e.target.checked });
                            }}
                            disabled={savedThisCard?.readOnly}
                            id="save_this_card"
                            name="savedThisCard"

                        />
                        <span className=' cursor-pointer inline-block relative text-base leading-[1.2] peer-checked:after:opacity-[1] peer-checked:before:border-[#000] peer-checked:before:bg-[#000] before:-content-[""] before:inline-block before:align-middle before:transition-all before:ease-in-out before:duration-300 before:mr-1 before:border-[2px] before:border-clr before:h-[24px] before:w-[24px] before:rounded-[3px] after:content-[""] after:transition-all after:ease-in-out after:duration-300 after:h-[7px] after:w-[14px] after:border-l-[2px] after:border-b-[2px] after:border-white after:absolute after:left-[5px] after:top-[7px] after:-rotate-[45deg] after:opacity-0'>Save My Card</span>
                    </label>
                </div>
            }
        </PAYMENT_STYLE >
    );
}

export default PaymentSection;